import { Center, Stack, Text, Title } from "@mantine/core";
import { Link } from "react-router-dom";

/** 404 fallback. Matched by `<Route path="*" />` in App.tsx. */
export function NotFoundPage(): JSX.Element {
  return (
    <Center h="100vh">
      <Stack align="center" gap="sm">
        <Title order={2}>Page not found</Title>
        <Text c="dimmed">The page you requested does not exist.</Text>
        <Link to="/">Return home</Link>
      </Stack>
    </Center>
  );
}
